import { Image } from "antd";

type Props = {
  countryName: string;
  width?: number;
};

export const CountryFlag = (props: Props) => {
  return (
    <Image
      width={props.width ?? 50}
      src={`https://cdn.countryflags.com/thumbs/${props.countryName
        .toLowerCase()
        .replaceAll(" ", "-")}/flag-round-500.png`}
      alt={`country flag of ${props.countryName}`}
      preview={false}
    />
  );
};
